import { render } from "./SubMenu.vue?vue&type=template&id=2aa2e3e6&ts=true"
import script from "./SubMenu.vue?vue&type=script&lang=ts"
export * from "./SubMenu.vue?vue&type=script&lang=ts"

import "./SubMenu.vue?vue&type=style&index=0&id=2aa2e3e6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__